import { Script, Env } from '@didi/utils'
import ajax from '@didi/ajax'

const SDK_URL = '//res.wx.qq.com/open/js/jweixin-1.3.2.js'

let cbs = []
let loaded = false
export function initWechat() {
  if (!Env.isWechat) {
    return
  }
  // 这是一个内部约定,保证多个sdk之间只能初始化一次微信
  if (window.__initWechat__) {
    // 进入这个逻辑说明其它的sdk正在初始化微信,那么需要等待初始化完毕
    waitForWechatReady()
    return
  }
  window.__initWechat__ = true
  Promise.all([requestJSSDKAPI(), loadWechatSDK()]).then((args) => {
    // 内部约定
    let res = args[0]
    const wx = window.wx

    const selfApiList = ['login', 'getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideOptionMenu', 'hideMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem']
    const userApiList = window._SDK_API_LIST_ || []
    wx.config({
      beta: true,
      debug: false,
      ...res.data,
      jsApiList: selfApiList.concat(userApiList)
    })

    wx.ready(() => {
      next(null)
      window.__wechatReady__ = true
      loaded = true
    })
  }).catch((e) => {
    next(e)
  })
}

function next(err) {
  cbs.forEach((cb) => {
    cb(err, window.wx)
  })
}

function waitForWechatReady() {
  function check() {
    if (window.__wechatReady__) {
      loaded = true
      next()
      return
    }
    setTimeout(check, 100)
  }

  check()
}

function loadWechatSDK() {
  if (window.wx === undefined) {
    return Script.loadScript(SDK_URL)
  } else {
    return Promise.resolve()
  }
}

function requestJSSDKAPI() {
  return new Promise((resolve, reject) => {
    const {url, method} = getSignApi()
    ajax({
      url,
      method,
      dataType: 'json',
      data: {
        url: window.location.href.replace(/#.*/, '')
      },
      success(res) {
        resolve(res)
      },
      error(status, statusText) {
        reject(statusText)
      }
    })
  })
}

function getSignApi() {
  // 宇宙大号
  return {
    url: '//common.diditaxi.com.cn/general/webEntry/jsapiticket',
    method: 'post'
  }
}

initWechat()

export function wechatReady(callback) {
  if (loaded) {
    callback(null, window.wx)
  } else {
    cbs.push(callback)
  }
}
